import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import EmptyMessageForum from '../components/common/EmptyMessageForum';
import SettingContext from '../contexts/settingContext';

import { LEADERBOARD, LEADERBOARD_EN } from '../utils/common/constant';
import LeaderboardList from '../components/forum/leaderboard/leaderboardList';
import { asyncReceiveLeaderboard } from '../middleware/leaderboards/action';
import { SectionLeaderboard } from '../components/styled';

const Leaderboardage = () => {
  const {
    leaderboards = [],
  } = useSelector((states) => states);
  const dispatch = useDispatch();
  const { locale } = React.useContext(SettingContext);

  React.useEffect(() => {
    dispatch(asyncReceiveLeaderboard());
  }, [dispatch]);

  const leaderboardList = leaderboards.map((leaderboard) => ({
    ...leaderboard,
  }));

  return (
    <SectionLeaderboard>
      <h2>{locale === 'id' ? LEADERBOARD : LEADERBOARD_EN}</h2>
      {
        Array.isArray(leaderboardList) && leaderboardList.length !== 0
          ? <LeaderboardList leaderboards={leaderboardList} />
          : <EmptyMessageForum archived={false} />
      }
    </SectionLeaderboard>
  );
};

export default Leaderboardage;
